import React, { useEffect } from "react";
import FontAwesome from "../../../utilities/FontAwesome";
import ApiClient from "../../../../backends/ApiClient";
import styles from "../styles/SchoolFeedBlock.module.scss";
import { SchoolFeedContentItem } from "../../../schoolfeed/SchoolFeedContentItem";
import classNames from "classnames";
import { useStores } from "../../../../stores/useStores";
import { IconButton, SegmentedControl } from "@radix-ui/themes";

interface FeedHeaderProps {
  currentView: string;
  handleCurrentViewChange: (view: string) => void;
  content: SchoolFeedContentItem[];
  currentViewOptions: { value: string; label: string }[];
  mutate: () => void;
}

const FeedHeader = (props: FeedHeaderProps) => {
  const { userStore, sidebarStore, organizationStore } = useStores();
  const [isSmallBlock, setIsSmallBlock] = React.useState(false);
  const feedHeaderClassNames = classNames({
    [styles.feedHeader]: true,
    [styles.feedHeaderSmallBlock]: isSmallBlock,
  });
  const headerRef = React.useRef<HTMLDivElement>(null);
  const canManageFeed =
    userStore.isEditor && organizationStore.currentOrganization.type !== "news";
  useEffect(() => {
    const element = headerRef.current;
    if (element) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          setIsSmallBlock(entry.contentRect.width < 300);
        }
      });
      resizeObserver.observe(element);
      return () => {
        if (element) {
          resizeObserver.unobserve(element);
        }
      };
    }
  }, []);
  return (
    <div className={feedHeaderClassNames} ref={headerRef}>
      <div className={styles.toggleButtonContainer}>
        <SegmentedControl.Root
          size="2"
          value={props.currentView}
          onValueChange={props.handleCurrentViewChange}
          title={"Switch between news and events"}
        >
          {props.currentViewOptions.map((option) => (
            <SegmentedControl.Item key={option.value} value={option.value}>
              {option.label}
            </SegmentedControl.Item>
          ))}
        </SegmentedControl.Root>
      </div>
      {canManageFeed && (
        <div className={styles.adminButtonContainer}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              sidebarStore.setSidebar({
                view: "SchoolFeedPost",
                handleSave: async (
                  contentItem,
                  organization,
                  post_to_facebook,
                ) => {
                  const client = await ApiClient();
                  await client.POST(
                    "/organizations/{organization_pk}/content-items/",
                    {
                      params: {
                        path: { organization_pk: organization.id },
                        query: { post_to_facebook: post_to_facebook },
                      },
                      body: contentItem,
                    },
                  );
                  await props.mutate();
                },
              });
            }}
            title={"Add New Post"}
            aria-label={"Add New Post"}
          >
            <FontAwesome prefix={"fas"} name={"fa-plus"} />
          </IconButton>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              sidebarStore.setSidebar({ view: "Social" });
            }}
            title={"Manage Sources"}
            aria-label={"Manage Sources"}
          >
            <FontAwesome prefix={"fas"} name={"fa-cog"} />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default FeedHeader;
